export const SMALL_SCREEN_LIMIT = '750px'
export const DAYS_PER_SEGMENT = 30
export const TABLET_SCREEN_LIMIT = '1024px'
export const MAX_ACTIVITY_COUNT = 5
